var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useSelector, useStore } from 'react-redux';
import { getIsInitialized, getIsProcessing } from '../store';
import { EngageBuilderLayout } from './builder-layout';
import { initializeCampaign } from './initialize-campaign';
import { useSession } from '../../../../infra/session';
import { useNavigate, useRouteParams } from '../../../../infra/routing';
import { endpoints } from '../../network';
import { buildApiPayloadAudiencesFromStore } from '../model-mapping/audiences';
import { canUseSmsChannel } from '../utils/delivery-channels';
import { useCampaignDetails } from '../hooks';
import { getCampaignOwnerOrViewerIdAndKind } from '../utils/get-campaign-owner-or-viewer-id-and-kind';
export var BuilderLayoutContainer = function (_a) {
    var children = _a.children;
    var store = useStore();
    var isInitialized = useSelector(getIsInitialized);
    var isProcessing = useSelector(getIsProcessing);
    var session = useSession().data;
    var campaignId = useRouteParams().campaignId;
    var navigate = useNavigate();
    var _b = useCampaignDetails(campaignId), campaign = _b.campaign, isCampaignDetailsLoading = _b.isLoading;
    var smsChannelEnabled = canUseSmsChannel({ session: session });
    var didInitializeRef = useRef(false);
    useEffect(function () {
        var button = document.querySelector('.c-btn--register-opener');
        var originalDisplay = (button === null || button === void 0 ? void 0 : button.style.display) || '';
        if (button) {
            button.style.display = 'none';
        }
        return function () {
            if (button) {
                button.style.display = originalDisplay;
            }
        };
    }, []);
    useEffect(function () {
        var _a;
        if (session && !didInitializeRef.current && !isCampaignDetailsLoading) {
            // making sure we only run this once per layout mount
            // the effect might be triggered multiple times when the campaign resets while existing the builder
            didInitializeRef.current = true;
            initializeCampaign({
                campaign: campaign,
                session: session,
                store: store,
                campaignId: campaignId,
                navigate: navigate,
            });
            var audiences = buildApiPayloadAudiencesFromStore({ session: session, store: store });
            var newClientsGroup = (_a = audiences.customerGroups) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
                var name = _a.name;
                return name === 'new';
            });
            var newCustomerWeeks = newClientsGroup === null || newClientsGroup === void 0 ? void 0 : newClientsGroup.weeks;
            var ownerOrViewerIdAndKind = getCampaignOwnerOrViewerIdAndKind(campaign, session);
            endpoints.audienceSegmentsQuery.prefetch(__assign({ ownerId: ownerOrViewerIdAndKind.id, ownerType: ownerOrViewerIdAndKind.kind }, (newCustomerWeeks ? { newCustomerWeeks: newCustomerWeeks } : {})));
            endpoints.clientsByChannelQuery.prefetch({
                ownerId: ownerOrViewerIdAndKind.id,
                ownerType: ownerOrViewerIdAndKind.kind,
                customerGroups: audiences.customerGroups.length > 0 ? audiences.customerGroups : [{ name: 'all' }],
                sms: smsChannelEnabled,
            });
            endpoints.promoCodesQuery.prefetch({
                ownerId: ownerOrViewerIdAndKind.id,
                ownerType: ownerOrViewerIdAndKind.kind,
            });
        }
    }, [isInitialized, session, campaignId, navigate, store, smsChannelEnabled, campaign, isCampaignDetailsLoading]);
    if (!isInitialized) {
        return null;
    }
    return _jsx(EngageBuilderLayout, { processing: isProcessing, children: children });
};
